import React from "react";
import { ForgotPassword } from "../../../components";

export const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};
